import { Fragment, type FunctionComponent } from "react";

import { BaseLinkContextProvider } from "scmp-app/components/common/base-link/context";
import { MenuItemAccordionList } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/accordion-list";
import { MenuItemHighlight } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/highlight";
import { MenuItemTopic } from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/topics";
import { tracking } from "scmp-app/data";
import type {
  BurgerMenuTabsItems,
  BurgerMenuTopTab,
} from "scmp-app/lib/app/hooks/scmp-pwa-burger-menu-config";
import { useScmpPwaBurgerMenuConfig } from "scmp-app/lib/app/hooks/scmp-pwa-burger-menu-config";
import { useCurrentPageType } from "scmp-app/lib/router/hooks";

import { useBurgerMenuTopics } from "./hooks";
import { Container } from "./styles";

type Props = {
  className?: string;
};

export const HamburgerMenuList: FunctionComponent<Props> = ({ className }) => {
  const { scmpPwaBurgerMenuConfigState } = useScmpPwaBurgerMenuConfig();
  const tobTab = scmpPwaBurgerMenuConfigState.result?.topTab as BurgerMenuTopTab;
  const tabs = scmpPwaBurgerMenuConfigState.result?.tabs as BurgerMenuTabsItems[];
  const topics = useBurgerMenuTopics();
  const pageType = useCurrentPageType();

  const renderMenuItem = (items: BurgerMenuTabsItems & BurgerMenuTopTab) => {
    if (items) {
      switch (items.type) {
        case "highlight":
          return <MenuItemHighlight items={items.items} />;
        case "accordion-list":
          return (
            <MenuItemAccordionList
              items={items.items}
              label={items?.button?.text}
              type={items.type}
            />
          );
        case "topics":
          return <MenuItemTopic label={items?.button?.text} reference={topics} type={items.type} />;
      }
    }
  };
  return (
    <Container className={className}>
      <BaseLinkContextProvider
        customQueryParameters={{
          module: tracking.module.HamburgerMenu,
          pgtype: pageType,
        }}
      >
        {renderMenuItem(tobTab)}
        {tabs?.map((tab, index) => <Fragment key={index}>{renderMenuItem(tab)}</Fragment>)}
      </BaseLinkContextProvider>
    </Container>
  );
};
